const MapPinCustom = ({ size = 24, color = 'currentColor', className = '', ...props }) => (
    <svg className={className} width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_2018_2086)'>
            <path d='M16.4284 7.64293C16.4284 11.9286 9.99986 16.9286 9.99986 16.9286C9.99986 16.9286 3.57129 11.9286 3.57129 7.64293C3.57129 4.1415 6.49843 1.21436 9.99986 1.21436C13.5013 1.21436 16.4284 4.1415 16.4284 7.64293Z' stroke={color} strokeWidth='1.2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M9.9993 9.78571C11.1828 9.78571 12.1422 8.82633 12.1422 7.64286C12.1422 6.45939 11.1828 5.5 9.9993 5.5C8.81583 5.5 7.85645 6.45939 7.85645 7.64286C7.85645 8.82633 8.81583 9.78571 9.9993 9.78571Z' stroke={color} strokeWidth='1.2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M15.8243 14.7859H17.1424L19.2853 19.7859H0.713867L2.85672 14.7859H4.17487' stroke={color} strokeWidth='1.2' strokeLinecap='round' strokeLinejoin='round' />
        </g>
        <defs>
            <clipPath id='clip0_2018_2086'>
                <rect width='20' height='20' fill='white' transform='translate(0 0.5)' />
            </clipPath>
        </defs>
    </svg>

);

export default MapPinCustom;
